import { useState, useEffect } from "react";
import { createContext } from "react";
import { useLocation } from "react-router-dom";
export const GlobalContext = createContext();
export default function Context(props) {
    const API_TOKEN = "75354dd215f31516bb233193ccbb1852";
    const SITE_ID = "30466"
    const CLUB_ID = "21849"
    // const SITE_ID = "11479"
    // const CLUB_ID = "10841"

    return (
        <GlobalContext.Provider value={{ API_TOKEN, SITE_ID, CLUB_ID }}>
            {props.children}
        </GlobalContext.Provider>
    )
}